import React, {Component} from 'react';
import {Form, Control, Errors} from 'react-redux-form'
import _ from "lodash";
import {isRequired} from "../field_validations";

export default class ObjectiveEditForm extends Component{
	render(){
		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="objectives.edit" onSubmit={(goals) => this._submitForm(goals)} onSubmitFailed={(error) => {this.props.setSystemNotification('¡Oh no!', 'Hay errores en el formulario', 'danger'); console.log('error', error)}}>
						<div className="field">
							<div className="control is-expanded">
								<label htmlFor="name" className="label">Nombre del Objetivo <span className="small has-text-danger">*</span></label>
								<Control.textarea model=".name" id="name" rows={2} className="textarea" placeholder="Nombre de la Meta" errors={{isRequired}} validateOn="change"/>
								<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El nombre es obligatorio'}} />
							</div>
						</div>

						<div className="field is-grouped">
							<div className="control">
								<label htmlFor="code" className="label">Código <span className="small has-text-danger">*</span></label>
								<Control.text model=".code" id="code" className="input" errors={{isRequired}} validateOn="change"/>
								<Errors model=".code" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'Campo Requerido', minLength2: 'Codigo no valido'}} />
							</div>
						</div>

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.push('/proigualdad/objetivos')}>
									Regresar
								</button>
							</div>
							<div className="control">
								<Control.button model="objectives.edit" className="button is-primary is-large" type="submit" disabled={this._validateSave()}>
									Guardar
								</Control.button>
							</div>
						</div>

						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		)
	}

	_submitForm(values) {
		this.props.objectiveEditSave(values);
	}

	_validateSave(){
		const {objectives} = this.props;
		let oc = _.find(objectives.permissions, (o) => {return o==='Create'});
		let ou = _.find(objectives.permissions, (o) => {return o==='Update'});

		if(!_.isEmpty(objectives.edit) && objectives.edit.id){
			if(ou){
				return false;
			}else {
				return true;
			}
		}else if(!_.isEmpty(objectives.edit) && _.isEmpty(objectives.edit.id)){
			if(oc){
				return false;
			}else {
				return true;
			}
		}else {
			return true;
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/objectives/form.jsx